import React from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";

function getIndex(value, arr, prop) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][prop] === value) {
      return i;
    }
  }
  return -1; //to handle the case where the value doesn't exist
}

function clean(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
      delete obj[propName];
    }
  }
  return obj;
}

function getRowData(tableMeta, columns) {
  const rowData = tableMeta.rowData.reduce((acc, val, index) => {
    acc[columns[index].name] = val;
    return acc;
  }, {});
  return rowData;
}

function getUserData() {
  const userData = localStorage.getItem("userData");
  return userData ? JSON.parse(userData) : null;
}


const updateObjectStateValue = (stateFunction, values) => {
  stateFunction((prevState) => ({
    ...prevState,
    ...values
  }))
}

const arrayColumn = (array, column) => {
  return array.map(item => item[column]);
};

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const capitalise = (string) => string?.charAt(0)?.toUpperCase() + string?.slice(1)

const truncatedText = (text, size) => text.length > size ? text.slice(0, size) + "..." : text;

const getSenioriteFromDate = (value) => {
  const formatedYear = moment(value).format("YYYY");
  let currentDate = new Date().getFullYear();
  if (formatedYear !== "Invalid date") {
    return currentDate - formatedYear;
  }
  return null;
};

const getRowDataSafe = (tableMeta, renderedColumns = []) => {
  try {
    const cols = Array.isArray(renderedColumns) ? renderedColumns : [];
    const row = {};
    cols.forEach((col, i) => {
      const key = col?.name || null;
      if (!key) return;
      row[key] = Array.isArray(tableMeta?.rowData) ? tableMeta.rowData[i] : undefined;
    });
    return row;
  } catch (_) {
    return {};
  }
};
const sortByNestedDate = (order) => (a, b) => {
  const dateA = a.data?.date ? new Date(a.data.date).getTime() : 0;
  const dateB = b.data?.date ? new Date(b.data.date).getTime() : 0;

  return (dateA - dateB) * (order === "asc" ? 1 : -1);
};
export { getIndex, truncatedText, clean, getUserData, capitalise, updateObjectStateValue, arrayColumn, useQuery, getRowData, getSenioriteFromDate, getRowDataSafe, sortByNestedDate };
